// Autogenerated file
export const avoidSpecialRoadFlagsEnum = {
    TRR: "TRR",
    MRR: "MRR",
    Cond: "Cond",
};
export const avoidSpecialRoadFlags = [
    { label: "Избегать ТТК", value: "TRR", intValue: 1 },
    { label: "Избегать МКАД", value: "MRR", intValue: 2 },
    { label: "Использовать сезонные ограничения", value: "Cond", intValue: 4 },
];
